import { useState, useEffect } from 'react';
import throttle from 'lodash/throttle';

import { IPosition } from 'shared/types/Position';

type MouseData = {
  x: number | null;
  y: number | null;
};

const initialMouseState: MouseData = {
  x: null,
  y: null,
};

function getMousePositionFromEvent(e: MouseEvent) {
  const { clientX, clientY } = e;

  return {
    x: clientX,
    y: clientY,
  };
}

export const useMousePosition = (throttleWait: number) => {
  const [position, setPosition] = useState<IPosition>(initialMouseState);

  function updateMousePosition(e: MouseEvent) {
    setPosition(getMousePositionFromEvent(e));
  }

  const throttledUpdateMousePosition = throttle(updateMousePosition, throttleWait);

  useEffect(() => {
    document.addEventListener('mousemove', throttledUpdateMousePosition);

    return () => {
      throttledUpdateMousePosition.cancel();
      document.removeEventListener('mousemove', throttledUpdateMousePosition);
    };
  }, []);

  return position;
};
